import axiosClient from "@/utils/axios-client";
import { CreateLineSheetProductRequestBody } from "@/shared/api/line-sheet-products/types";
import { lineSheetProductsUrl } from "@/shared/api/line-sheet-products/url";

export const lineSheetProductsMutationApi = {
  // 라인시트 탭에 상품 추가
  createLineSheetProduct: async (
    agencyId: number,
    lineSheetSetId: number,
    lineSheetId: number,
    lineSheetTabIndex: number,
    params: CreateLineSheetProductRequestBody
  ) =>
    await axiosClient.post(
      lineSheetProductsUrl.root(
        agencyId,
        lineSheetSetId,
        lineSheetId,
        lineSheetTabIndex
      ),
      params
    ),
};
